import { createContext, useState } from 'react';

const SearchContext = createContext();

const SearchProvider = ({ children }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchTags, setSearchTags] = useState([]);
  const [fromSearch, setFromSearch] = useState(false)

  return (
    <SearchContext.Provider value={{ searchResults, setSearchResults, searchTags, setSearchTags, fromSearch, setFromSearch }}>
      {children}
    </SearchContext.Provider>
  );
};

export { SearchProvider, SearchContext };